module.exports = {
  "name": "sel-2022",
  "client": "Mobile spot",
  "description": "Mobile app for test",
  "validLangs": ["fr", "en"],
  "version": {
    "mainVersion": "2.0.1",
    "buildVersion": {
      "iOS": "76",
      "android": "75",
      "web": "76"
    }
  },
  "native": {
    "author": "Mobile-Spot",
    "backgroundColor": "0xffffff",
    "iosBuildTarget": "11.0",
    "androidFadeSplashScreenDuration": 750,
    "androidTargetSdkVersion": 30,
    "androidSigning": {
      "keyAlias": "mobilespotmom",
      "keyStorePassword": "jee1Uu0Hieloh7ba"
    },
    "app": "app-react"
  },
  "undeliveredFolders": ["source", "exports"],
  "crypto": false,
  "web": {}
};